import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeNavigationFunction = new EventEmitter();
  subsVar: Subscription;
  private menuItem: any;

  constructor() {}

  onNavigationClick(link: string, params: any) {
    this.menuItem = {
      link,
      params
    };
    localStorage.setItem('menu_item', JSON.stringify(this.menuItem));
    this.invokeNavigationFunction.emit(this.menuItem);
  }

  getMenuItem(chromeTabs) {
    if (chromeTabs) {
      const found = localStorage.getItem('menu_item');
      return found ? JSON.parse(found) : null;
    } else {
      return this.menuItem;
    }
  }

  freeMenuItem() {
    this.menuItem = null;
    localStorage.removeItem('menu_item');
  }
}
